import { Injectable } from '@angular/core';
import { BehaviorSubject, finalize, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AssinaturaDocumento } from '../models/assinatura-documento';
import { HttpClient, HttpParams } from '@angular/common/http';
import { StatusDocumentoAssinatura } from '../models/status-documento';
import { downloadDocumentoSimplificado } from '../models/download-documento.mode';
import { UploadArquivoResponse } from '../models/upload-arquivo-response.model';
import { ListaDocumentoAssinatura } from '../models/lista-documento-assinatura.mode';
import { FiltrarListarDocumentosAssinatura } from '../models/filtro-listar-documentos.model';
import { CancelarDocumentoModal } from '../models/cancelar-documento.modal';

@Injectable({
  providedIn: 'root'
})
export class AssinarDocumentoService {
  private _apiUrl = environment.apiUrl + "/v1/AssinarDocumento";
  private loadingSubject = new BehaviorSubject<boolean>(true);

  public get loading() {
    return this.loadingSubject.value;
  }

  constructor(private http: HttpClient) { }

  uploadArquivo(arquivo: FormData): Observable<UploadArquivoResponse> {
    return this.http.post<UploadArquivoResponse>(`${this._apiUrl}/upload-arquivo`, arquivo)
      .pipe(finalize(() => this.loadingSubject.next(false)))
  }

  adcionarSignatarios(assinaturaDocumento: AssinaturaDocumento): Observable<AssinaturaDocumento> {
    return this.http.post<AssinaturaDocumento>(`${this._apiUrl}/adicionar-signatario`, assinaturaDocumento)
      .pipe(finalize(() => this.loadingSubject.next(false)))
  }

  consultarDocumentoAssinatura(contratoId: string): Observable<StatusDocumentoAssinatura> {
    return this.http.get<StatusDocumentoAssinatura>(`${this._apiUrl}/documentos/${contratoId}`)
      .pipe(finalize(() => this.loadingSubject.next(false)))
  }

  downloadDocumentoSimplificado(documentoUuId: string): Observable<downloadDocumentoSimplificado> {
    return this.http.get<downloadDocumentoSimplificado>(`${this._apiUrl}/documentos/${documentoUuId}/download-simplificado`)
      .pipe(finalize(() => this.loadingSubject.next(false)))
  }

  enviarParaAssinar(documentoUuid: string): Observable<StatusDocumentoAssinatura> {
    let payload = {
      documentoUuid: documentoUuid
    }

    return this.http.post<StatusDocumentoAssinatura>(`${this._apiUrl}/solicitar-assinatura-email`, payload)
      .pipe(finalize(() => this.loadingSubject.next(false)))
  }

  consultarDocumentosTotalizadores(filtro: FiltrarListarDocumentosAssinatura): Observable<ListaDocumentoAssinatura> {

    let params = new HttpParams();
    Object.entries(filtro).forEach(([key, value]) => {
      if (value) {
        params = params.append(key, value.toString());
      }
    });

    this.loadingSubject.next(true);

    return this.http.get<ListaDocumentoAssinatura>(`${this._apiUrl}/listar-documentos`, { params })
      .pipe(
        finalize(() => this.loadingSubject.next(false)),
      )
  }

  cancelarDocumento(documentoUuId: string): Observable<string> {

    return this.http.delete<string>(`${this._apiUrl}/cancelar-documento/${documentoUuId}`)
      .pipe(finalize(() => this.loadingSubject.next(false)))

  }
}
